import { AbstractControlOptions, FormGroup } from "@angular/forms";
import { LControlType } from "../types";
import { SSFormControl } from "./ss-form-control";

export class SSFormGroup extends FormGroup {

  constructor(
    private _controls: { [dataField: string]: SSFormControl },
    options?: AbstractControlOptions
  ) {
    super(_controls, options);
  }


  override get<TControlType extends LControlType = LControlType>(dataField: string): SSFormControl<TControlType> {
    return this._controls[dataField] as SSFormControl<TControlType>;
  }
}
